import React from "react";

import ModalContainer from "../common/modals/ModalContainer";
import RoutesComponent from "../routes";


const App = () => {

  return (
    <div className="App">
      <ModalContainer />
      <RoutesComponent />
    </div>
  );
};

export default App;
